import { cn } from '../../lib/utils';

/** Aether mark — an abstract aurora orbit. */
export function LogoMark({ className }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('h-7 w-7', className)} fill="none" aria-hidden>
      <defs>
        <linearGradient id="aether-grad" x1="0" y1="0" x2="32" y2="32">
          <stop offset="0%" stopColor="#827bff" />
          <stop offset="50%" stopColor="#34e7e4" />
          <stop offset="100%" stopColor="#e85bff" />
        </linearGradient>
      </defs>
      <circle cx="16" cy="16" r="6" fill="url(#aether-grad)" />
      <ellipse
        cx="16"
        cy="16"
        rx="13"
        ry="6"
        stroke="url(#aether-grad)"
        strokeWidth="1.6"
        transform="rotate(35 16 16)"
        opacity="0.9"
      />
      <ellipse
        cx="16"
        cy="16"
        rx="13"
        ry="6"
        stroke="url(#aether-grad)"
        strokeWidth="1.6"
        transform="rotate(-35 16 16)"
        opacity="0.55"
      />
    </svg>
  );
}

export default function Logo({ className, textClassName }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark />
      <span className={cn('font-display text-lg font-semibold tracking-tight text-content', textClassName)}>
        Aether
      </span>
    </span>
  );
}
